export default __webpack_public_path__ + "static/media/fondo.61d7e7e8.jpg";